import script from "./ChatHelloMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatHelloMessage.vue?vue&type=script&setup=true&lang=js"

import "./ChatHelloMessage.vue?vue&type=style&index=0&id=70efdf98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2_clean-css@5.3.3_c_e59ecb87855333ab161cabc1a794339b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70efdf98"]])

export default __exports__